document.addEventListener("DOMContentLoaded", async () => {
  const modal = document.getElementById("offer-modal");
  const modalButton = document.querySelector(".product-discount-modal-button");
  const closeModal = document.querySelector(".offer-modal-close");
  const modalBody = document.querySelector(".offer-modal-body.eligible");
  const iEModalBody = document.querySelector(".offer-modal-body.ineligible");

  // Show modal when clicking the button
  modalButton.addEventListener("click", async () => {
    modal.classList.add("show");
    document.body.classList.add("no-scroll"); // Disable background scrolling

    // Fetch and display all offers inside the modal
    modalBody.innerHTML = "";
    let unlockElement = iEModalBody.querySelector(".ineligible-title"); // Clear previous content
    iEModalBody.innerHTML = ""; // Clear previous content for ineligible offers
    const offersData = window.allOffers.pdpOffers; // Fetch eligible offers
    const inEligibleOffersData = window.allOffers.inEligibleOffers.pdpOffers; // Fetch ineligible offers

    // Display eligible offers
    offersData.forEach((offer, index) => {
      modalBody.innerHTML += window.BlazeSDK.generatePDPOfferHTML(
        offer,
        index,
        true,
      );
    });

    // Display ineligible offers
    if (inEligibleOffersData.length > 0) {
      iEModalBody.append(unlockElement);
      inEligibleOffersData
      .sort((a, b) => {
        const cartTotal = window.allOffers.cartData.cartTotal;
        const diffA = a.offerRules.amount.minOrderAmount - cartTotal;
        const diffB = b.offerRules.amount.minOrderAmount - cartTotal;
  
        if (diffA === diffB) {
          return b.orderBreakup.offerAmount - a.orderBreakup.offerAmount;
        }
  
        return diffA - diffB;
      })
      .forEach((offer, index) => {
        iEModalBody.innerHTML += window.BlazeSDK.generatePDPOfferHTML(
          offer,
          index + 1,
          true,
        );
      });
      iEModalBody.querySelectorAll(".unlock-offer").forEach((unlockButton) => {
        unlockButton.classList.remove("hidden");
      });
      iEModalBody.classList.remove("hidden");
    }
  });

  // Close modal when clicking on the close button
  closeModal.addEventListener("click", () => {
    modal.classList.remove("show");
    document.body.classList.remove("no-scroll"); // Enable background scrolling
  });

  // Close modal when clicking outside the modal content
  window.addEventListener("click", (event) => {
    if (event.target == modal) {
      modal.classList.remove("show");
      document.body.classList.remove("no-scroll"); // Enable background scrolling
    }
  });
});
